/* Vista Panel de Control para /eventos/:id
Vista que trae toda la info del evento, muestra el dashboard de tarifas vendidas y sus accesos */
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loading from "../../components/Loading";
import { api } from "../../services/api";
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, } from 'chart.js';
import { useMediaQuery } from "react-responsive";
import { FastfoodOutlined, ConfirmationNumberOutlined, HowToRegOutlined, PendingActionsOutlined, DateRangeOutlined, VerifiedUserOutlined, MoreVert, FileDownloadOutlined } from "@mui/icons-material";
import LinearProgress from '@mui/material/LinearProgress';
import { toast, Bounce } from 'react-toastify';
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import VendedorDashboard from "./VentaPresencial";
import ResumenCaja from "./ResumenCaja";
import { UserContext } from "../../components/ProtectedRoutes/UserContext";
import { CircularProgress, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import useEventoStore from "../../stores/useEventoStore";
import { ROL } from "../../domain/staff/roles";
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale);

export const Evento = () => {
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null,
  });
  const history = useHistory();
  const [evento, setEvento] = useState();
  const [stateEvento, setStateEvento] = useState();
  const [publicaciones, setPublicaciones] = useState();
  const [tarifas, setTarifas] = useState();
  const { setUserRole } = useContext(UserContext);
  const [rolUsuario, setRolUsuario] = useState(null);
  const [idRol, setIdRol] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const param = useParams();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const { fetchEvento } = useEventoStore();

  const [filteredTickets, setFilteredTickets] = useState([]);
  const [filteredVouchers, setFilteredVouchers] = useState([]);

  const [selectedDate, setSelectedDate] = useState("all");

  const [availableDates, setAvailableDates] = useState([]);

  useEffect(() => {
    const callApi = async () => {
      try {
        setLoading(true);
        const data = await fetchEvento(param.id);
        if (data) {
          setEvento(data.evento);

          const allTickets = data.eventosumary?.tickets || [];
          const allVouchers = data.eventosumary?.vouchers || [];
          setTickets(allTickets);
          setVouchers(allVouchers);

          const allDates = new Set();
          allTickets.forEach((ticket) => {
            ticket.fechas_asignadas?.forEach((fecha) => { if (fecha) allDates.add(fecha); });
          });
          allVouchers.forEach((voucher) => {
            voucher.fechas_asignadas?.forEach((fecha) => { if (fecha) allDates.add(fecha); });
          });

          const sortedDates = Array.from(allDates).sort();
          const initialDate = sortedDates.length > 1 ? "all" : sortedDates[0];
          setAvailableDates(sortedDates);

          if (sortedDates.length > 0) {
            setSelectedDate(initialDate);
            filterByDate(allTickets, allVouchers, initialDate);
          } else {
            filterByDate(allTickets, allVouchers, selectedDate);
          }

          setStateEvento(data.evento.id_estados_eventos);
          setPublicaciones(data.publicacionessumary);
          setTarifas(data.tarifassumary);

          const eventoUsuario = data.eventoUsuario;
          if (eventoUsuario) {
            setUserRole(eventoUsuario.idrol);
            setIdRol(eventoUsuario.idrol);
            const rolNombre = eventoUsuario.rol?.rol;
            if (rolNombre === "Vendedor") setRolUsuario("Vendedor");
            else if (rolNombre === "Tesorero") setRolUsuario("Tesorero");
            else setRolUsuario("Owner");
          }
        }
      } catch (error) {
        setState({ ...state, error: "Error en la Red." });
      } finally {
        setLoading(false);
      }
    };
    callApi();
  }, [param.id, setUserRole]);

  useEffect(() => {
    if (tickets && tickets.length > 0) {
      filterByDate(tickets, vouchers, selectedDate);
    }
  }, [selectedDate, tickets, vouchers]);


  const filterByDate = (allTickets, allVouchers, date) => {
    if (!date) return;

    // si selecciona "todas", mostrar todo
    if (date === "all") {
      setFilteredTickets(allTickets.map(ticket => ({
        ...ticket,
        escaneadosAcumulados: ticket.consumidos || 0,
        escaneadosEnFecha: ticket.consumidos || 0,
        acreditadosAcumulados: ticket.acreditados || 0,
        acreditadosEnFecha: ticket.acreditados || 0,
        pendientes: ticket.cantidad - (ticket.consumidos || 0)
      })));
      setFilteredVouchers(allVouchers.map(voucher => ({
        ...voucher,
        acreditadosAcumulados: voucher.acreditados || 0,
        escaneadosAcumulados: voucher.escaneados || 0,
        escaneadosEnFecha: voucher.escaneados || 0,
        pendientes: voucher.cantidad - (voucher.escaneados || 0)
      })));
      return;
    }

    const ticketsForDate = allTickets?.filter(ticket =>
      ticket.fechas_asignadas && ticket.fechas_asignadas.includes(date)
    ) || [];

    const vouchersForDate = allVouchers?.filter(voucher =>
      voucher.fechas_asignadas && voucher.fechas_asignadas.includes(date)
    ) || [];

    const ticketsWithCalculatedStats = ticketsForDate.map(ticket => {
      const updatedTicket = { ...ticket };

      let escaneadosAcumulados = 0;
      let escaneadosEnFecha = 0;
      let acreditadosAcumulados = 0;
      let acreditadosEnFecha = 0;

      const tieneEscaneosPorFechaValidos = ticket.escaneos_por_fecha &&
        ticket.escaneos_por_fecha.some(escaneo => escaneo.consumidos > 0 || escaneo.acreditados > 0);

      if (ticket.preimpreso && tieneEscaneosPorFechaValidos) {
        ticket.escaneos_por_fecha.forEach(escaneo => {
          // sumar todos los escaneos de la fecha seleccionada y posteriores
          if (escaneo.fecha >= date) {
            escaneadosAcumulados += escaneo.consumidos;
            acreditadosAcumulados += escaneo.acreditados || 0;
          }
          if (escaneo.fecha === date) {
            escaneadosEnFecha = escaneo.consumidos;
            acreditadosEnFecha = escaneo.acreditados || 0;
          }
        });
      } else {
        escaneadosAcumulados = ticket.consumidos || 0;
        acreditadosAcumulados = ticket.acreditados || 0;
        escaneadosEnFecha = ticket.consumidos || 0;
        acreditadosEnFecha = ticket.acreditados || 0;
      }

      updatedTicket.escaneadosAcumulados = escaneadosAcumulados;
      updatedTicket.escaneadosEnFecha = escaneadosEnFecha;
      updatedTicket.acreditadosAcumulados = acreditadosAcumulados;
      updatedTicket.acreditadosEnFecha = acreditadosEnFecha;
      updatedTicket.pendientes = ticket.cantidad - escaneadosAcumulados;

      return updatedTicket;
    });

    const vouchersWithCalculatedStats = vouchersForDate.map(voucher => {
      const updatedVoucher = { ...voucher };

      // los vouchers acreditados serian los que tienen un idcompra
      // eso para los vouchers preimpresos que se han ido vendiendo. existen con idcompra null y al vender se rellena
      const acreditadosAcumulados = voucher.acreditados || 0;

      const escaneadosAcumulados = voucher.escaneados || 0;

      updatedVoucher.acreditadosAcumulados = acreditadosAcumulados;
      updatedVoucher.escaneadosAcumulados = escaneadosAcumulados;
      updatedVoucher.pendientes = voucher.cantidad - escaneadosAcumulados;

      return updatedVoucher;
    });

    setFilteredTickets(ticketsWithCalculatedStats);
    setFilteredVouchers(vouchersWithCalculatedStats);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleFinalizarConfiguracion = () => {
    if (evento.privado === false && tarifas.count === 0) {
      history.push(`/eventos/${param.id}/tarifas`);
    } else if (evento.privado === false && publicaciones.count === 0) {
      history.push(`/eventos/${param.id}/publicaciones`);
    } else {
      api.eventos.confirmEvento(param.id)
        .then(response => {
          if (response.status === 'success') {
            toast.success('Tu evento se ha publicado exitosamente', {
              position: 'top-center',
              autoClose: 2000,
              theme: 'dark',
              transition: Bounce,
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        })
        .catch(error => {
          toast.error('Hubo un problema al confirmar el evento', {
            position: 'top-center',
            autoClose: 3000,
            theme: 'dark',
          });
        });
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(`${dateString}T12:00:00`);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return date.toLocaleDateString('es-ES', options);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElID, setAnchorElID] = useState(null);
  const openSeeMore = Boolean(anchorEl);

  const handleClickSeeMore = (e) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
    setAnchorElID(e.currentTarget.id)
  }

  const handleCloseSeeMore = (e) => {
    setAnchorEl(null)
    setAnchorElID(null)
  }

  const handleDescargarReporteTickets = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteVentasTickets(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_venta_tickets_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success('Reporte descargado correctamente', {
        position: 'top-center',
        autoClose: 2000,
        theme: 'dark',
        transition: Bounce,
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      toast.error('Error al descargar el reporte:', error.message, {
        position: "top-center",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDescargarReporteVouchers = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteVentasVouchers(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_venta_vouchers_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success('Reporte descargado correctamente', {
        position: 'top-center',
        autoClose: 2000,
        theme: 'dark',
        transition: Bounce,
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      toast.error('Error al descargar el reporte:', error.message, {
        position: "top-center",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDescargarReporteRecaudacion = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteRecaudacion(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_recaudacion_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success('Reporte descargado correctamente', {
        position: 'top-center',
        autoClose: 2000,
        theme: 'dark',
        transition: Bounce,
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      toast.error('Error al descargar el reporte:', error.message, {
        position: "top-center",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDescargarReporteCajas = async () => {
    try {
      setLoading(true);

      const blob = await api.reporte.downloadReporteCajas(param.id);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      link.download = `reporte_cajas_${fechaActual}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success('Reporte descargado correctamente', {
        position: 'top-center',
        autoClose: 2000,
        theme: 'dark',
        transition: Bounce,
      });
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
      toast.error('Error al descargar el reporte:', error.message, {
        position: "top-center",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {evento && !loading && (
        <Container fluid="sm">
          {rolUsuario === "Vendedor" ? (
            <>
              <VendedorDashboard eventoId={param.id} evento={evento} />
            </>
          ) : rolUsuario === "Tesorero" ? (
            <>
              <ResumenCaja eventoId={param.id} evento={evento} />
            </>
          ) : (
            <>
              {stateEvento === 1 ? (
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div style={{ width: "90%" }}>
                    <div className="" style={{ color: "#8C2828", border: "1px solid #D02A2A", borderRadius: "5px", padding: "20px 15px", backgroundColor: "rgba(255, 180, 180, 0.2)" }}>
                      <div className="">
                        <p className="mb-2 fw-bold fs-4"> {(evento.privado === false && tarifas.count === 0) || (evento.privado === false && publicaciones.count === 0)
                          ? "Tu evento no está listo"
                          : "Evento listo para publicar"}</p>
                        <p className="mb-1 fs-6" style={{ color: "#8C2828" }}>
                          {evento.privado === false
                            ? (
                              tarifas.count === 0 && publicaciones.count === 0
                                ? "Tu evento no tiene tarifas ni publicaciones configuradas. Completa estos detalles para que el evento esté listo para ser publicado."
                                : (tarifas.count === 0
                                  ? "Aún no has configurado tarifas para tu evento. Por favor, agrega al menos una tarifa para publicar el evento."
                                  : (publicaciones.count === 0
                                    ? "Aún no has creado una publicación para tu evento. Agrega una publicación para que los usuarios puedan verlo."
                                    : null
                                  )
                                )
                            )
                            : (
                          /* tarifas.count === 0
                            ? "Aún no has configurado tarifas para tu evento. Por favor, agrega al menos una tarifa para publicar el evento."
                            : */ null
                            )
                          }
                        </p>
                        <div className="d-flex align-items-center justify-content-end">
                          <button type="button" onClick={handleFinalizarConfiguracion} style={{ color: "#3D2EAB" }}>
                            {(evento.privado === false && tarifas.count === 0) || (evento.privado === false && publicaciones.count === 0)
                              ? "Finalizar configuración"
                              : "Publicar evento"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "30px", padding: "0px 25px", flexDirection: "column", height: "100%" }}>
                    <div className="d-flex justify-content-end mb-3">
                      {availableDates.length > 0 && (
                        <div className="date-selector-container" style={{
                          padding: "10px",
                          borderRadius: "8px",
                          boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <DateRangeOutlined sx={{ color: "#3D2EAB", marginRight: "8px" }} />
                          <select
                            value={selectedDate}
                            onChange={handleDateChange}
                            className="form-select"
                            style={{ border: "none", boxShadow: "none", minWidth: "200px" }}
                          >
                            {availableDates.length > 1 && (
                              <option value="all">Todas las fechas</option>
                            )}
                            {availableDates.map(date => (
                              <option key={date} value={date}>
                                {formatDateDisplay(date)}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      {/* los reportes de ventas y recaudación son para owner y cliente (el backend lo exige) */}
                      {(idRol === ROL.OWNER || idRol === ROL.CLIENTE) && (<>
                      <IconButton
                        aria-label="see more"
                        id={param.id}
                        aria-controls={openSeeMore ? 'long-menu' : undefined}
                        aria-expanded={openSeeMore ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleClickSeeMore}
                        sx={{ p: 0 }}
                        className="ms-auto"
                      >
                        <MoreVert />
                      </IconButton>
                      <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseSeeMore}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            handleCloseSeeMore();
                            handleDescargarReporteTickets();
                          }}
                        >
                          <ListItemIcon>
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              <FileDownloadOutlined sx={{ color: "#5656FF" }} />
                            )}
                          </ListItemIcon>
                          {loading ? (
                            <ListItemText>Descargando reporte..</ListItemText>
                          ) : (
                            <ListItemText>Venta de Tickets</ListItemText>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleCloseSeeMore();
                            handleDescargarReporteVouchers();
                          }}
                        >
                          <ListItemIcon>
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              <FileDownloadOutlined sx={{ color: "#5656FF" }} />
                            )}
                          </ListItemIcon>
                          {loading ? (
                            <ListItemText>Descargando reporte..</ListItemText>
                          ) : (
                            <ListItemText>Venta de Vouchers</ListItemText>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleCloseSeeMore();
                            handleDescargarReporteRecaudacion();
                          }}
                        >
                          <ListItemIcon>
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              <FileDownloadOutlined sx={{ color: "#5656FF" }} />
                            )}
                          </ListItemIcon>
                          {loading ? (
                            <ListItemText>Descargando reporte..</ListItemText>
                          ) : (
                            <ListItemText>Recaudación diaria</ListItemText>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleCloseSeeMore();
                            handleDescargarReporteCajas();
                          }}
                        >
                          <ListItemIcon>
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              <FileDownloadOutlined sx={{ color: "#5656FF" }} />
                            )}
                          </ListItemIcon>
                          {loading ? (
                            <ListItemText>Descargando reporte..</ListItemText>
                          ) : (
                            <ListItemText>Recaudación Cajas</ListItemText>
                          )}
                        </MenuItem>
                      </Menu>
                      </>)}
                    </div>

                    <div className="d-flex flex-column">
                      <p style={{ fontSize: "28px", marginBottom: "0px" }}>Tickets</p>
                      {filteredTickets?.length > 0 ? (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                          {filteredTickets?.map((tarifa, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                                width: isMobile ? "100%" : "225px",
                                borderRadius: "12px",
                              }}
                            >
                              <div style={{ padding: "20px 15px", display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }}>
                                <div className="d-flex flex-row align-items-center justify-content-between">
                                  <div className="d-flex flex-column">
                                    <p style={{ marginBottom: "0", fontSize: "14px", lineHeight: "22px", letterSpacing: "0.15px" }}>
                                      {tarifa.concepto}
                                    </p>
                                    <p style={{ fontSize: "28px", lineHeight: "32px" }}>{tarifa.cantidad}</p>
                                  </div>
                                  <div
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      borderRadius: "50%",
                                      marginBottom: "10px",
                                      backgroundColor: "#e4f3fc",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <ConfirmationNumberOutlined sx={{ fontSize: "30px", color: "#067bea" }} />
                                  </div>
                                </div>
                                <div>
                                  {tarifa.preimpreso && (
                                    <>
                                      <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                        Acreditados
                                      </p>
                                      <div className="d-flex flex-row align-items-center">
                                        <VerifiedUserOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                        <LinearProgress
                                          variant="determinate"
                                          value={(tarifa.acreditadosAcumulados / tarifa.cantidad) * 100}
                                          sx={{
                                            height: "10px !important",
                                            width: isMobile ? "75%" : "140px",
                                            minWidth: isMobile ? "75%" : "140px",
                                            maxWidth: isMobile ? "75%" : "140px",
                                            borderRadius: "5px",
                                            backgroundColor: "#F5F5F5",
                                            '& .MuiLinearProgress-bar': {
                                              backgroundColor: '#059669',
                                              borderRadius: "5px"
                                            },
                                          }}
                                        />
                                        <div className="ml-auto">
                                          <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                            {tarifa.acreditadosAcumulados}
                                          </p>
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px", marginTop: tarifa.preimpreso ? "8px" : "0px" }}>
                                    Consumidos
                                  </p>
                                  <div className="d-flex flex-row align-items-center">
                                    <HowToRegOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                    <LinearProgress
                                      variant="determinate"
                                      value={(tarifa.escaneadosAcumulados / tarifa.cantidad) * 100}
                                      sx={{
                                        height: "10px !important",
                                        width: isMobile ? "75%" : "140px",
                                        minWidth: isMobile ? "75%" : "140px",
                                        maxWidth: isMobile ? "75%" : "140px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F5F5F5",
                                        '& .MuiLinearProgress-bar': {
                                          backgroundColor: '#9797E4',
                                          borderRadius: "5px"
                                        },
                                      }}
                                    />
                                    <div className="ml-auto">
                                      <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                        {tarifa.escaneadosAcumulados}
                                      </p>
                                    </div>
                                  </div>
                                  <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                    Pendientes
                                  </p>
                                  <div className="d-flex flex-row  align-items-center">
                                    <PendingActionsOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                    <LinearProgress
                                      variant="determinate"
                                      value={(tarifa.pendientes / tarifa.cantidad) * 100}
                                      sx={{
                                        height: "10px !important",
                                        width: isMobile ? "75%" : "140px",
                                        minWidth: isMobile ? "75%" : "140px",
                                        maxWidth: isMobile ? "75%" : "140px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F5F5F5",
                                        '& .MuiLinearProgress-bar': {
                                          backgroundColor: '#4837C5',
                                          borderRadius: "5px"
                                        },
                                      }}
                                    />
                                    <div className="ml-auto">

                                      <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                        {tarifa.pendientes || 0}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "between",
                            alignItems: "center",
                            boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                            width: "250px",
                            height: "auto",
                            borderRadius: "12px",
                            padding: "20px"
                          }}>
                          <p style={{ marginBottom: "0", fontSize: "16px", lineHeight: "20px", letterSpacing: "0.15px" }}>Aun no tienes tickets registrados</p>
                          <div
                            style={{
                              width: "55px",
                              height: "45px",
                              borderRadius: "50%",
                              backgroundColor: "#e4f3fc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <ConfirmationNumberOutlined sx={{ fontSize: "20px", color: "#067bea" }} />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex flex-column">
                      {filteredVouchers?.length > 0 && (
                        <>
                          <p style={{ fontSize: "28px", marginBottom: "0px" }}>Venta Presencial</p>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", flexDirection: "row" }}>
                            {filteredVouchers?.map((tarifa, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                                  width: isMobile ? "100%" : "225px",
                                  borderRadius: "12px",
                                }}
                              >
                                <div style={{ padding: "20px 15px", display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }}>
                                  <div className="d-flex flex-row align-items-center justify-content-between">
                                    <div className="d-flex flex-column">
                                      <p style={{ marginBottom: "0", fontSize: "14px", lineHeight: "22px", letterSpacing: "0.15px" }}>
                                        {tarifa.concepto}
                                      </p>
                                      <p style={{ fontSize: "28px", lineHeight: "32px" }}>{tarifa.cantidad}</p>
                                    </div>
                                    <div
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        marginBottom: "10px",
                                        backgroundColor: "#e4f3fc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FastfoodOutlined sx={{ fontSize: "30px", color: "#067bea" }} />
                                    </div>
                                  </div>
                                  <div>
                                    <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                      Acreditados
                                    </p>
                                    <div className="d-flex flex-row align-items-center">
                                      <VerifiedUserOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                      <LinearProgress
                                        variant="determinate"
                                        value={(tarifa.acreditadosAcumulados / tarifa.cantidad) * 100}
                                        sx={{
                                          height: "10px !important",
                                          width: isMobile ? "75%" : "140px",
                                          minWidth: isMobile ? "75%" : "140px",
                                          maxWidth: isMobile ? "75%" : "140px",
                                          borderRadius: "5px",
                                          backgroundColor: "#F5F5F5",
                                          '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#059669',
                                            borderRadius: "5px"
                                          },
                                        }}
                                      />
                                      <div className="ml-auto">
                                        <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                          {tarifa.acreditadosAcumulados}
                                        </p>
                                      </div>
                                    </div>
                                    <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                      Reclamados
                                    </p>
                                    <div className="d-flex flex-row justify-content-around align-items-center">
                                      <HowToRegOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                      <LinearProgress
                                        variant="determinate"
                                        value={(availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados) / tarifa.cantidad * 100}
                                        sx={{
                                          height: "10px !important",
                                          width: isMobile ? "75%" : "140px",
                                          minWidth: isMobile ? "75%" : "140px",
                                          maxWidth: isMobile ? "75%" : "140px",
                                          borderRadius: "5px",
                                          backgroundColor: "#F5F5F5",
                                          '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#9797E4',
                                            borderRadius: "5px"
                                          },
                                        }}
                                      />
                                      <div className="ml-auto">
                                        <p style={{ color: "black", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                          {availableDates.length > 1 ? tarifa.escaneadosEnFecha : tarifa.escaneadosAcumulados}
                                        </p>
                                      </div>
                                    </div>
                                    <p style={{ fontSize: "10px", lineHeight: "16px", letterSpacing: "0.15px", marginBottom: "3px" }}>
                                      Pendientes
                                    </p>
                                    <div className="d-flex flex-row justify-content-around align-items-center">
                                      <PendingActionsOutlined sx={{ color: "black", width: "16px", height: "16px", marginRight: "4px" }} />
                                      <LinearProgress
                                        variant="determinate"
                                        value={((tarifa.cantidad - tarifa.escaneados) / tarifa.cantidad) * 100}
                                        sx={{
                                          height: "10px !important",
                                          width: isMobile ? "75%" : "140px",
                                          minWidth: isMobile ? "75%" : "140px",
                                          maxWidth: isMobile ? "75%" : "140px",
                                          borderRadius: "5px",
                                          backgroundColor: "#F5F5F5",
                                          '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#4837C5',
                                            borderRadius: "5px"
                                          },
                                        }}
                                      />
                                      <div className="ml-auto">
                                        <p style={{ color: "black", fontSize: "18px", lineHeight: "24px", letterSpacing: "0.15px", marginBottom: "0", marginLeft: "3px" }}>
                                          {tarifa.cantidad - tarifa.escaneados}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}

        </Container >
      )}
    </>
  );
};
export default withAuthenticationRequired(Evento, {
  onRedirecting: () => <Loading />,
});